// extracted by mini-css-extract-plugin
export default {"imageWrapper":"MK-z","twoColumnImage":"NK-z"};